import axiosConfig from './axiosConfig';

export const projectApi = {
  getAll: async (params = {}) => {
    const response = await axiosConfig.get('/projects', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosConfig.get(`/projects/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axiosConfig.post('/projects', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosConfig.put(`/projects/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosConfig.delete(`/projects/${id}`);
    return response.data;
  },

  getStats: async (id) => {
    const response = await axiosConfig.get(`/projects/${id}/stats`);
    return response.data;
  },
};